// extracted by mini-css-extract-plugin
export default {"wrapper":"SuperuserNav-SuperuserNav-module__wrapper--HeTCS","links":"SuperuserNav-SuperuserNav-module__links--LCJEd"};